(function(window, undefined) {

    'use strict';



    /**
     * @class IframeWrapper
     *
     * @constructor IframeWrapper.IframeWrapper
     * @param {Object} o
     * @... {         String}          markup               markup string which will fill the iframe
     * @... {optional Element|String}  container            container element/id. will append to it
     * @... {optional String}          className            class name to apply to the iframe
     * @... {optional String}          name                 name to apply to the iframe
     * @... {optional String}          id                   id to apply to the iframe
     * @... {optional String}          onReadyCallbackName  tried to call given function name from parent window once ready
     */
    var IframeWrapper = function(o) {
        this._options = o;

        this._oldMode = (SAPO.Browser.IE && ~~(SAPO.Browser.version) < 10);

        // container
        if (!o.container) {
            o.container = document.body;
        }
        else {
            o.container = s$(o.container);
        }
        this._container = o.container;

        // base fixing
        if (this._oldMode) {
            this._baseEl = document.querySelector('base[target]');
            if (this._baseEl) {
                // console.log('BASE EXISTS');
                this._baseTargetValue = this._baseEl.getAttribute('target');
            }
            else {
                // console.log('NEW BASE');
                this._baseEl = document.createElement('base');
                o.container.appendChild(this._baseEl);
            }
            this._baseEl.setAttribute('target', '_self');
        }

        // iframe creation
        var iframeEl = document.createElement('iframe');
        if (o.className) {
            iframeEl.className = o.className;
        }
        if (o.name) {
            iframeEl.setAttribute('name', o.name);
        }
        if (o.id) {
            iframeEl.setAttribute('id', o.id);
        }

        var s = iframeEl.style;
        s.border = 0;
        iframeEl.setAttribute('frameBorder',           '0');
        iframeEl.setAttribute('scrolling',             'no');
        iframeEl.setAttribute('allowfullscreen',       '');
        iframeEl.setAttribute('mozallowfullscreen',    '');
        iframeEl.setAttribute('webkitallowfullscreen', '');
        this._iframeEl = iframeEl;

        o.container.appendChild(iframeEl);

        // call me once ready...
        if (o.onReadyCallbackName) {
            var innerCb = function(v) {
                v._iframeEl = this._iframeEl;
                v._parentContainerEl = this._container;
            };
            window[o.onReadyCallbackName] = innerCb.bindObj(this);
        }

        // markup attribution
        var iframeWin = iframeEl.contentWindow;
        if (this._oldMode) {
            /*jshint scripturl:true*/
            iframeWin.contents = o.markup;
            iframeEl.setAttribute('target', '_self');
            iframeEl.src = 'javascript:window["contents"]';
        }
        else {
            iframeWin.document.open('text/html', 'replace');
            iframeWin.document.write(o.markup);
            iframeWin.document.close();
        }
        this._window = iframeWin;

        if (this._oldMode) {
            if (this._baseTargetValue) {
                // console.log('BASE SET');
                this._baseEl.setAttribute('target', this._baseTargetValue);
            }
            else {
                // console.log('BASE REMOVE');
                this._baseEl.parentNode.removeChild( this._baseEl );
            }
        }
    };

    IframeWrapper.prototype = {
        getOuterWindow: function() {
            return window;
        },

        getInnerWindow: function() {
            return this._window;
        },

        getContainer: function() {
            return this._container;
        },

        getIframe: function() {
            return this._iframeEl;
        }
    };



    SAPO.namespace('Utility');
    SAPO.Utility.IframeWrapper = IframeWrapper;

})(window);
